import styled from '@emotion/styled';

export const IconWrapperLoader = styled.div<{ height?: string }>`
	display: flex;
	justify-content: center;
	height: ${({ height }) => (height ? height : '80vh')};
	width: 100%;
`;
